
import { useState, useEffect } from 'react';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}

export default function VideoModal({ isOpen, onClose, videoUrl }: VideoModalProps) {
  const [showContinue, setShowContinue] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setShowContinue(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center">
      <div className="relative w-full h-full max-w-6xl max-h-screen">
        {showContinue && (
          <button
            onClick={onClose}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 bg-[#b8144a] hover:bg-[#a01240] text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 backdrop-blur-sm shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Continue to Website
          </button>
        )}
        
        <video
          className="w-full h-full object-cover"
          autoPlay
          onEnded={onClose}
          controls={false}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center text-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-2">Christ + Nothing = Enough</h2>
          <p className="text-lg opacity-90">Peter Akinnubi Apostolic Ministry</p>
        </div>
      </div>
    </div>
  );
}
